import axios from 'axios'

// Global defaults
axios.defaults.baseURL = '/api'

// 封装失败返回结果
var errorRes = {
    code: 99,
    message: ''
}

axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['If-Modified-Since'] = '0'

var interceptor = axios.interceptors.response.use(response => {
    let {c, r, i} = response.data
    let res
    switch (c) {
        case 0:
            // 成功则直接返回数据对象
            res = Promise.resolve(r)
            break
        default:
            // 各种失败统一封装
            console.log(i)
            errorRes.code = c
            errorRes.message = i
            res = Promise.reject(errorRes)
            break
    }
    return res
}, function (error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
    console.log(error.config);


    errorRes.code = 99
    errorRes.message = 'Service unavailable, please try again later.'

    return Promise.reject(errorRes)
})

axios.instance = function(){
    var instance = axios.create();
    instance.interceptors.response.eject(interceptor);
    return instance
}

export default axios


// WEBPACK FOOTER //
// ./src/api/api.js